// extracted by mini-css-extract-plugin
module.exports = {"responses":"Responses_responses__lcXE2"};